export default __webpack_public_path__ + "static/media/email-grey.a82da159.svg";